//
//  JSBridge.js
//  JSBridge
//
//  Created by Siva RamaKrishna Ravuri
//  Copyright (c) 2014 www.siva4u.com. All rights reserved.
//
// The MIT License (MIT)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//
//

;(function (w, doc) {
    if (w.JSBridge) return;

// PRIVATE VARIABLES
    //!!! WARNING - Should be in SYNC with Native Code defines - Begin
//  var JSBRIDGE_URL_SCHEME  = 'jsbridgeurlscheme';//Whitsunday
//  var JSBRIDGE_URL_MESSAGE = '__JSB_URL_MESSAGE__';
//  var JSBRIDGE_URL_EVENT   = '__JSB_URL_EVENT__';
//  var JSBRIDGE_URL_API   = 'JSBRIDGE_URL_API';

    var JSBRIDGE_URL_SCHEME  = 'https';//Whitsunday
    var JSBRIDGE_URL_EVENT = 'JSB_EVENT';
    var JSBRIDGE_URL_API = 'JSB_API';

    //!!! WARNING - Should be in SYNC with Native Code defines - End

    var ua = navigator.userAgent;
    var isIOSDevice = /iP(hone|od|ad)/g.test(ua);
    var isAndroidDevice = /Android/g.test(ua);
    var isWechat = /micromessenger/i.test(ua);
    var sendMessageQueue = [];
    var receiveMessageQueue = [];
    var messageHandlers = {};//本地注册的方法集合,原生只能调用本地注册的方法,否则会提示错误
    var responseCallbacks = {};//定义的回调函数集合,在原生调用完对应的方法后,会执行对应的回调函数id
    var apiData = null;
    var uniqueId = 1;//唯一id,用来确保每一个回调函数的唯一性
    var messagingIframe;

// PRIVATE METHODS
    if(isWechat)return;

    function JSBridgeLog() {
        if (typeof console != 'undefined') {
            console.log("JSBridge:JS: LOG: ", arguments);
        }
    }

    function JSBridgeLogException(e, m) {
        if (typeof console != 'undefined') {
            console.error("JSBridge:JS: EXCEPTION: ", arguments);
        }
    }

    function getIFrameSrc(param) {
//      return JSBRIDGE_URL_SCHEME + '://' + JSBRIDGE_URL_MESSAGE + '/'+ param;
        return JSBRIDGE_URL_SCHEME + '://' + param + ":3000";
    }

    function callObjCAPI(name, data) {
        // Should not called triggerNativeCall as iFrame needs to be deleted in order to get the retvalue.
        var iframe = document.createElement("IFRAME");
        apiData = {api: name};
        if (data) apiData["data"] = data;
        iframe.setAttribute("src", getIFrameSrc(JSBRIDGE_URL_API));
        document.documentElement.appendChild(iframe);
        iframe.parentNode.removeChild(iframe);
        iframe = null;

        var ret = JSBridge.nativeReturnValue;
        JSBridge.nativeReturnValue = undefined;
        if (ret) return decodeURIComponent(ret);
    };

//ios中,通过截取客户端url访问
//因为ios可以不暴露scheme,而是由原生手动获取
//正在调用的方法详情添加进入消息队列中,原生会主动获取

//安卓需要转为字符串，通过特定方法传参；

    function triggerNativeCall() {
        if (isIOSDevice) {
            messagingIframe.src = getIFrameSrc(JSBRIDGE_URL_EVENT);
        } else {
//          var apiName = ((isAndroidDevice)?("AndroidAPI.ProcessJSEventQueue"):("WebAppAPI.ProcessJSEventQueue"));
            try {
                if (AndroidAPI.ProcessJSEventQueue) {
//              	alert(_fetchJSEventQueue());
                    AndroidAPI.ProcessJSEventQueue(_fetchJSEventQueue());
                }
                /*
                 * 废弃兼容性不好
                 * 
                 * var api = eval(apiName);
                if(api) api(_fetchJSEventQueue());*/
            } catch (e) {
            }
        }
    }

    /**
     * @description JS调用原生方法前,会先send到这里进行处理
     * @param {JSON} message 调用的方法详情,包括方法名,参数
     * @param {Function} responseCallback 调用完方法后的回调
     */
    function doSend(message, responseCallback) {
        if (responseCallback) {
            var callbackId = 'cb_' + (uniqueId++) + '_' + new Date().getTime();//取到一个唯一的callbackid
            console.log(callbackId);
            responseCallbacks[callbackId] = responseCallback;//取到一个唯一的callbackid
            message['callbackId'] = callbackId;//方法的详情添加回调函数的关键标识
        }
        sendMessageQueue.push(message);// 
        triggerNativeCall();
    }


    //_handleMessageFromNative( JSON )
//Native调用原生调用H5注册的方法，或者通知H5页面执行回调方法
//messageJSON 对应的方法的详情,需要手动转为json
    function dispatchMessageFromNative(messageJSON) {
        setTimeout(function _timeoutDispatchMessageFromObjC() {
            var message = JSON.parse(messageJSON);
            var messageHandler;
            var responseCallback;

            if (message.responseId) {//这里规定,原生执行方法完毕后准备通知h5执行回调时,回调函数id是responseId
                responseCallback = responseCallbacks[message.responseId];
                if (!responseCallback) {
                    return;
                }
                responseCallback(message.responseData);//执行本地的回调函数
                delete responseCallbacks[message.responseId];
            } else {//否则,代表原生主动执行h5本地的函数
                if (message.callbackId) {
                    //先判断是否需要本地H5执行回调函数
                    //如果需要本地函数执行回调通知原生,那么在本地注册回调函数,然后再调用原生
                    //回调数据有h5函数执行完毕后传入
                    var callbackResponseId = message.callbackId;
                    responseCallback = function (responseData) {
                        doSend({responseId: callbackResponseId, responseData: responseData});
                    }//默认是调用EJS api上面的函数
                    //然后接下来原生知道scheme被调用后主动获取这个信息
                    //所以原生这时候应该会进行判断,判断对于函数是否成功执行,并接收数据
                    //这时候通讯完毕(由于h5不会对回调添加回调,所以接下来没有通信了)
                }

                try {//从本地注册的函数中获取
                    var handler = ((message.eventName) ? (messageHandlers[message.eventName]) : (JSBridge.bridgeHandler));
                    if (handler) {//执行本地函数,按照要求传入数据和回调
                        handler(message.data, responseCallback);
                    }
                } catch (e) {
                    JSBridgeLogException(e, "dispatchMessageFromNative原生调用H5方法出错,传入参数错误");
                }
            }
        });
    }

    function getReturnObject(apiName, status, dataJson) {
        var outJson = {status: status};
        if (apiName) outJson["apiName"] = apiName;
        if (dataJson) outJson["data"] = dataJson;
        return outJson;
    }


// PUBLIC METHODS
    function init(bridgeHandler) {
        if (JSBridge.bridgeHandler) {
            JSBridgeLogException(e, "init");
        }
        JSBridge.bridgeHandler = bridgeHandler;
        var receivedMessages = receiveMessageQueue;
        receiveMessageQueue = null;
        for (var i = 0; i < receivedMessages.length; i++) {
            dispatchMessageFromNative(receivedMessages[i]);
        }
    }

    function send(eventName, data, responseCallback) {
        var dataToSend = {};
        if (eventName) dataToSend["eventName"] = eventName;
        dataToSend["data"] = {status: "true"};
        if (data) dataToSend["data"]["data"] = data;
        doSend(dataToSend, responseCallback);
    }

//registerHandler( String,Function )H5调用 注册本地JS方法,注册后Native可通过JSBridge调用。调用后会将方法注册到本地变量messageHandlers 中
    //注册一个测试函数

    function registerEvent(eventName, handler) {
        messageHandlers[eventName] = handler;
    }

    function deRegisterEvent(eventName, handler) {
        if (messageHandlers[eventName]) {
            delete messageHandlers[eventName];
        }
    }

//callHandler( String,JSON,Function)
//H5调用 调用原生开放的api,调用后实际上还是本地通过url scheme触发。调用时会将回调id存放到本地变量responseCallbacks中
//callbackId,handlerName,data
    function callAPI(name, data, responseCallback) {
        console.log("JSBridgeCoreFunc");
        try {
            if (data) {
                if (responseCallback) {
                    var cbID = "cbID" + (+new Date);
                    responseCallbacks[cbID] = responseCallback;
                    data["callbackID"] = cbID;
                }
                try {
                    data = JSON.stringify(data);
                } catch (e) {
                }
            }

            if (isIOSDevice) {
                if (data) name += ":";
                return callObjCAPI(name, data);
            } else {
                if (AndroidAPI.ProcessJSAPIRequest) {
                    if (data) return AndroidAPI.ProcessJSAPIRequest(name, data);
                    return AndroidAPI.ProcessJSAPIRequest(name, null);
                } else {
                    JSBridgeLogException("Unsupported API:", name); //报错
                }
                /*
                 * 废弃不兼容
                 * 
                var api = eval((isAndroidDevice)?("AndroidAPI.ProcessJSAPIRequest"):("WebAppAPI.ProcessJSAPIRequest"));
                 * if(api) {
                	if(data) return api(name,data);
                	return api(name,null);
                } else {
                    JSBridgeLogException("Unsupported API:",name); //报错
                }*/
            }
        } catch (e) {
            JSBridgeLogException(e, "Invalid API:" + name); //抛出异常
        }
    }

    function callAPICallback(apiCallback, outJson, status) {
        if (apiCallback) {
            apiCallback(getReturnObject(null, ((status) ? (status) : ("true")), outJson));
        }
    }

    function callEventCallback(responseCallback, outJson, inJson) {
        if (responseCallback) {
            responseCallback(getReturnObject(((inJson) ? (inJson["eventName"]) : (null)), "true", outJson));
        }
    }

    function _fetchJSEventQueue() {
        try {
            var messageQueueString = JSON.stringify(sendMessageQueue);
            sendMessageQueue = [];
            return messageQueueString;
        } catch (e) {
            JSBridgeLogException(e, "_fetchJSEventQueue");
        }
        return [];
    }

    function _handleMessageFromNative(messageJSON) { //JSon
        if (receiveMessageQueue) {
            receiveMessageQueue.push(messageJSON);
        } else {
            dispatchMessageFromNative(messageJSON);
        }
    }

    function _getAPIData() {
        return JSON.stringify(apiData);
    }

    function _invokeJSCallback(cbID, removeAfterExecute, config) {
        if (cbID) {
            var cb = responseCallbacks[cbID];
            if (cb) {
                if (removeAfterExecute) delete (responseCallbacks[cbID]);
                var data = config;
                if (isAndroidDevice) {
                    try {
                        data = JSON.parse(config);
                    } catch (e) {
                    }
                }
                if (data.callbackID) delete (data.callbackID);
                cb.call(null, data);
            }
        }
    };

    w.JSBridge = {
        init: init.bind(this),
        send: send.bind(this),
        callAPI: callAPI.bind(this),

        registerEvent: registerEvent.bind(this),
        deRegisterEvent: deRegisterEvent.bind(this),

        callAPICallback: callAPICallback.bind(this),
        callEventCallback: callEventCallback.bind(this),

        _fetchJSEventQueue: _fetchJSEventQueue.bind(this),
        _handleMessageFromNative: _handleMessageFromNative.bind(this),
        _getAPIData: _getAPIData.bind(this),
        _invokeJSCallback: _invokeJSCallback.bind(this),
    }

    messagingIframe = doc.createElement('iframe');
    messagingIframe.style.display = 'none';
    triggerNativeCall();
    doc.documentElement.appendChild(messagingIframe);

    var readyEvent = doc.createEvent('Events');
    readyEvent.initEvent('JSBridgeReady');
    readyEvent.bridge = JSBridge;
    doc.dispatchEvent(readyEvent);

})(window, document);
